import React, { FC, useEffect } from 'react';
import Navbar from '../components/navbar';

interface Props {
   className?: string;
}

const LayoutIndex: FC<Props> = (props) => {
   const { children, className } = props;

   const cls = `page-${className}`;

   useEffect(() => {
      className && document.documentElement.classList.add(cls);
      return () => {
         className && document.documentElement.classList.remove(cls);
      };
   }, [className, cls]);
   return (
      <>
         <Navbar />
         {children}
      </>
   );
};

export default LayoutIndex;
